export default __webpack_public_path__ + "static/app-features-2-318a4a18280e7c9be67365bf5d80205d.webp";